import React, { FC } from 'react';
import { Formik } from 'formik';
import { Form } from 'formik-antd';
import { object } from 'yup';
import { FormikOnSubmit } from 'lib/formik.utils';
import {
  dateOfBirthValidationSchema,
  requiredEmailValidationSchema,
  firstNameValidationSchema,
  genderValidationSchema,
  idNumberValidationSchema,
  lastNameValidationSchema,
  phoneNumberValidationSchema,
  phoneNumberPrefixCodeValidation,
} from 'common/config/validationSchema';
import { defaultFormLayout } from 'common/config/formLayout';
import { SaveButton } from 'common/components/SaveButton';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { BusinessPartnerProfileOwnerFormItems } from 'pages/BusinessPartnerManagement/BusinessPartnerProfileOwnersManagement/BusinessPartnerRegisterProfileOwnerPage/BusinessPartnerRegisterProfileOwnerFormItems';
export type BusinessPartnerRegisterProfileOwner = {
  partner: any;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  gender: string;
  idNumber: string;
  idNumberDocumentType: string;
  email: string;
  phoneNumber: string;
  prefixCode: string;
};

const initialValues: BusinessPartnerRegisterProfileOwner = {
  partner: '',
  firstName: '',
  lastName: '',
  dateOfBirth: '',
  gender: '',
  idNumber: '',
  idNumberDocumentType: 'NON_REQUIRED',
  email: '',
  phoneNumber: '',
  prefixCode: '',
};

export interface BusinessPartnerRegisterProfileOwnerFormProps {
  onSubmit: FormikOnSubmit<BusinessPartnerRegisterProfileOwner>;
  loading?: boolean;
}

export const BusinessPartnerRegisterProfileOwnerForm: FC<BusinessPartnerRegisterProfileOwnerFormProps> = ({
  onSubmit,
  loading = false,
}) => {
  const intlMessage = useFormatMessage();

  const validationSchema = object().shape(
    {
      firstName: firstNameValidationSchema(intlMessage),
      lastName: lastNameValidationSchema(intlMessage),
      email: requiredEmailValidationSchema(intlMessage),
      dateOfBirth: dateOfBirthValidationSchema(intlMessage),
      gender: genderValidationSchema(intlMessage),
      idNumber: idNumberValidationSchema(intlMessage),
      phoneNumber: phoneNumberValidationSchema(intlMessage),
      prefixCode: phoneNumberPrefixCodeValidation(intlMessage),
    },
    [['prefixCode', 'phoneNumber']]
  );

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      <Form {...defaultFormLayout}>
        <BusinessPartnerProfileOwnerFormItems />

        <SaveButton loading={loading} />
      </Form>
    </Formik>
  );
};
